import classNames from "classnames";
import React from "react";
import Heading from "../../elements/heading";
import Videojs from "../../components/video-js";
import PropTypes from "prop-types";
import "./style.scss";
import { getOverallSettingsClasses } from "../../utils/siteUtils";

const LocalHeroIntro = ({ fields, rendering }) => {
  const {
    logo,
    sound,
    video,
    videoAutoPlay,
    videoPlayText,
    headingBody,
    headingType,
    image
  } = fields;

  const heroIntroClasses = classNames(
    "hero-intro grid", getOverallSettingsClasses(fields)
  );

  const logoClasses = classNames("logo");
  const mediaClasses = classNames("media-container");

  const videoOptions =
    video && video.value
      ? {
        sources: [
          {
            src: video.value.src,
            type: video.value.mimeType
          }
        ],
        poster: image.value.src,
        videoTitle: videoPlayText && videoPlayText.value,
        autoplay: videoAutoPlay.value,
        controls: true,
        muted: !sound.value
      }
      : {};

  return (
    <div className={heroIntroClasses} datasourceid={rendering.dataSource}>
      <div className={mediaClasses}>
        <div className={logoClasses}>
          <img src={logo.value.src} alt={logo.value.alt}></img>
        </div>
        <div className="heading">
          <Heading html={headingBody} type={headingType} />
        </div>
      </div>
      {video.value != null && (
        <div className="video">
          <Videojs {...videoOptions} />
        </div>
      )}
      {video.value == null && image.value != null && (
        <div className="image">
          <img src={image.value.src} alt={image.value.alt}></img>
        </div>
      )}
    </div>
  );
};

LocalHeroIntro.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    paddingAboveBottom: PropTypes.object,
    paddingAboveTop: PropTypes.object,
    logo: PropTypes.object,
    sound: PropTypes.object,
    video: PropTypes.object,
    videoAutoPlay: PropTypes.object,
    videoPlayText: PropTypes.object,
    headingBody: PropTypes.object,
    headingType: PropTypes.object,
    image: PropTypes.object
  })
};

export default LocalHeroIntro;
